import { Text, TextProps } from '@chakra-ui/react'

const baseStyle = {
  fontFamily: "Inter, sans-serif",
  letterSpacing: "0%",
  color: "onBackground"
}

export const textV4Variants = {
  // V1.0
  // DISPLAY
  'chakra_display_large': {
    ...baseStyle,
    fontFamily: 'Poppins',
    fontWeight: '600',
    fontSize: '57px',
    lineHeight: '85.5px',
    letterSpacing: '-0.5px',
  },
  'chakra_display_medium': {
    ...baseStyle,
    fontFamily: 'Poppins',
    fontWeight: '500',
    fontSize: '45px',
    lineHeight: '67.5px',
  },
  'chakra_display_small': {
    ...baseStyle,
    fontFamily: 'Poppins',
    fontWeight: '500',
    fontSize: '36px',
    lineHeight: '54px',
  },

  // HEADLINE
  'chakra_headline_large': {
    ...baseStyle,
    fontFamily: 'Poppins',
    fontWeight: '400',
    fontSize: '32px',
    lineHeight: '48px',
    letterSpacing: '0.3px',
  },
  'chakra_headline_medium': {
    ...baseStyle,
    fontFamily: 'Poppins',
    fontWeight: '500',
    fontSize: '28px',
    lineHeight: '42px',
    letterSpacing: '-1%',
  },
  'chakra_headline_small': {
    ...baseStyle,
    fontFamily: 'Poppins',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
  },

  // TITLE
  'chakra_title_large': {
    ...baseStyle,
    fontFamily: 'Poppins',
    fontWeight: '400',
    fontSize: '22px',
    lineHeight: '33px',
    letterSpacing: '0.3px',
  },
  'chakra_title_medium': {
    ...baseStyle,
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '18.75px',
    letterSpacing: '0.15px',
  },
  'chakra_title_small': {
    ...baseStyle,
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '16.41px',
    letterSpacing: '0.1px',
  },

  // LABEL
  'chakra_label_large': {
    ...baseStyle,
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
  },
  'chakra_label_medium': {
    ...baseStyle,
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.5px',
  },
  'chakra_label_small': {
    ...baseStyle,
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '11px',
    lineHeight: '16px',
    letterSpacing: '0.5px',
  },

  // BODY
  'chakra_body_large': {
    ...baseStyle,
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.5px',
  },
  'chakra_body_medium': {
    ...baseStyle,
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  'chakra_body_small': {
    ...baseStyle,
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
  },

  // V4.0
  // MOBILE LARGE 
  v4_mobile_m_large_title_regular: {
    ...baseStyle,
    fontSize: "34px",
    fontWeight: 400,
  },
  v4_mobile_m_large_title_semibold: {
    ...baseStyle,
    fontSize: "34px",
    fontWeight: 600,
  },
  v4_mobile_m_large_title_bold: {
    ...baseStyle,
    fontSize: "34px",
    fontWeight: 700,
  },

  // MOBILE TITLE 1 
  v4_mobile_m_title_1_regular: {
    ...baseStyle,
    fontSize: "28px",
    fontWeight: 400,
  },
  v4_mobile_m_title_1_semibold: {
    ...baseStyle,
    fontSize: "28px",
    fontWeight: 600,
  },
  v4_mobile_m_title_1_bold: {
    ...baseStyle,
    fontSize: "28px",
    fontWeight: 700,
  },

  // MOBILE TITLE 2 
  v4_mobile_m_title_2_regular: {
    ...baseStyle,
    fontSize: "22px",
    fontWeight: 400,
  },
  v4_mobile_m_title_2_semibold: {
    ...baseStyle,
    fontSize: "22px",
    fontWeight: 600,
  },
  v4_mobile_m_title_2_bold: {
    ...baseStyle,
    fontSize: "22px",
    fontWeight: 700,
  },

  // MOBILE TITLE 3 
  v4_mobile_m_title_3_regular: {
    ...baseStyle,
    fontSize: "20px",
    fontWeight: 400,
  },
  v4_mobile_m_title_3_semibold: {
    ...baseStyle,
    fontSize: "20px",
    fontWeight: 600,
  },
  v4_mobile_m_title_3_bold: {
    ...baseStyle,
    fontSize: "20px",
    fontWeight: 700,
  },

  // MOBILE BODY 
  v4_mobile_m_body_regular: {
    ...baseStyle,
    fontSize: "17px",
    fontWeight: 400,
  },
  v4_mobile_m_body_semibold: {
    ...baseStyle,
    fontSize: "17px",
    fontWeight: 600,
  },
  v4_mobile_m_body_bold: {
    ...baseStyle,
    fontSize: "17px",
    fontWeight: 700,
  },

  // MOBILE CALLOUT 
  v4_mobile_m_callout_regular: {
    ...baseStyle,
    fontSize: "16px",
    fontWeight: 400,
  },
  v4_mobile_m_callout_semibold: {
    ...baseStyle,
    fontSize: "16px",
    fontWeight: 600,
  },
  v4_mobile_m_callout_bold: {
    ...baseStyle,
    fontSize: "16px",
    fontWeight: 700,
  },

  // MOBILE SUBHEAD 
  v4_mobile_m_subhead_regular: {
    ...baseStyle,
    fontSize: "15px",
    fontWeight: 400,
  },
  v4_mobile_m_subhead_semibold: {
    ...baseStyle,
    fontSize: "15px",
    fontWeight: 600,
  },
  v4_mobile_m_subhead_bold: {
    ...baseStyle,
    fontSize: "15px",
    fontWeight: 700,
  },

  // MOBILE FOOTNOTE 
  v4_mobile_m_footnote_regular: {
    ...baseStyle,
    fontSize: "13px",
    fontWeight: 400,
  },
  v4_mobile_m_footnote_semibold: {
    ...baseStyle,
    fontSize: "13px",
    fontWeight: 600,
  },
  v4_mobile_m_footnote_bold: {
    ...baseStyle,
    fontSize: "13px",
    fontWeight: 700,
  },

  // MOBILE CAPTION 1 
  v4_mobile_m_caption_1_regular: {
    ...baseStyle,
    fontSize: "12px",
    fontWeight: 400,
  },
  v4_mobile_m_caption_1_semibold: {
    ...baseStyle,
    fontSize: "12px",
    fontWeight: 600,
  },
  v4_mobile_m_caption_1_bold: {
    ...baseStyle,
    fontSize: "12px",
    fontWeight: 700,
  },

  // MOBILE CAPTION 2 
  v4_mobile_m_caption_2_regular: {
    ...baseStyle,
    fontSize: "11px",
    fontWeight: 400,
  },
  v4_mobile_m_caption_2_semibold: {
    ...baseStyle,
    fontSize: "11px",
    fontWeight: 600,
  },
  v4_mobile_m_caption_2_bold: {
    ...baseStyle,
    fontSize: "11px",
    fontWeight: 700,
  },

  // DESKTOP 
  v4_dekstop_d_large_title_regular: {
    ...baseStyle,
    fontSize: "26px",
    fontWeight: 400,
  },
  v4_dekstop_d_large_title_bold: {
    ...baseStyle,
    fontSize: "26px",
    fontWeight: 700,
  },
  v4_dekstop_d_title_1_regular: {
    ...baseStyle,
    fontSize: "22px",
    fontWeight: 400,
  },
  v4_dekstop_d_title_2_regular: {
    ...baseStyle,
    fontSize: "17px",
    fontWeight: 400,
  },
  v4_dekstop_d_title_3_regular: {
    ...baseStyle,
    fontSize: "15px",
    fontWeight: 400,
  },
  v4_dekstop_d_headline: {
    ...baseStyle,
    fontSize: "13px",
    fontWeight: 600,
  },
  v4_dekstop_d_headline_semibold: {
    ...baseStyle,
    fontSize: "13px",
    fontWeight: 600,
  },
  v4_dekstop_d_body: {
    ...baseStyle,
    fontSize: "13px",
    fontWeight: 400,
  },
  v4_dekstop_d_body_regular: {
    ...baseStyle,
    fontSize: "13px",
    fontWeight: 400,
  },
  v4_dekstop_d_callout_regular: {
    ...baseStyle,
    fontSize: "12px",
    fontWeight: 400,
  },
  v4_dekstop_d_subheadline_regular: {
    ...baseStyle,
    fontSize: "11px",
    fontWeight: 400,
  },
  v4_dekstop_d_caption_1_regular: {
    ...baseStyle,
    fontSize: "10px",
    fontWeight: 400,
  },
} as const

export type TextV4Variant = keyof typeof textV4Variants

export interface TextV4Props
  extends Omit<TextProps, "variant"> {
  variant?: TextV4Variant
}

export default function TextV4({
  variant = "v4_dekstop_d_body_regular",
  ...rest
}: TextV4Props) {
  return (
    <Text
      {...textV4Variants[variant]}
      {...rest}
    />
  )
}
